import * as io from "io-ts";
import type { ISimpleEvent } from "ste-simple-events";

export const ihrCookieName = "iheart-user";

export function isIHeartDomain(hostname: string): boolean {
  const lower = hostname.toLowerCase();
  return lower === "localhost" || lower.endsWith(".iheart.com");
}

const RequiredPrivacyFields = io.type({
  hasOptedOut: io.boolean,
  usPrivacy: io.string,
});

const RequiredProfileFields = io.type({
  profileId: io.number,
  sessionId: io.string,
});

const OptionalProfileFields = io.partial({
  birthYear: io.number,
  profileId: io.number,
  sessionId: io.string,
  email: io.string,
  emailHashes: io.array(io.string),
  country: io.string,
  entitlements: io.array(io.unknown),
  gender: io.string,
  privacy: RequiredPrivacyFields,
  isAnonymous: io.boolean,
  zipCode: io.string,
  authType: io.string,
  accountType: io.string,
  name: io.string,
  birthDay: io.number,
  birthMonth: io.number,
  marketName: io.string,
  phoneNumber: io.string,
});

const _IHeartUserProfile = io.intersection([RequiredProfileFields, OptionalProfileFields]);

const _SessionState = io.type({
  authenticated: io.boolean,
  pid: io.string,
  aid: io.string,
});

// INFO: this is for backwards compatibility w/ 3rd party services (igloo tag, gtm, etc.); which will be sync'd with localStorage
export const IHRSessionStateResolver = io.intersection([
  _SessionState,
  io.partial({
    profile: _IHeartUserProfile,
  }),
]);

export const IHRServerSessionStateResolver = io.type({
  profile: _IHeartUserProfile,
});

export type IHeartUserProfile = io.TypeOf<typeof _IHeartUserProfile>;
export type SessionState = io.TypeOf<typeof _SessionState>;
export type IHRSessionState = io.TypeOf<typeof IHRSessionStateResolver>;
export type IHRServerSessionState = io.TypeOf<typeof IHRServerSessionStateResolver>;
export interface SessionBackend<T = IHRSessionState> {
  name: string;
  state: T;
  onStatusChanged: ISimpleEvent<T>;
  authenticated: boolean;
  hasPrivacy: boolean;
  container?: string;
  login(): Promise<T> | Promise<any>;
  signup(): Promise<T> | Promise<any>;
  logout(): Promise<T>;
  refresh(): Promise<T>;
}
